import axios from "axios";

class Ip {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.ip4Container = self.elem.querySelector('[data-ip-four-container]');
        self.ip6Container = self.elem.querySelector('[data-ip-six-container]');
        self.ip4Elem = self.elem.querySelector('[data-ip-four]');
        self.ip6Elem = self.elem.querySelector('[data-ip-six]');
        self.ip4CopyButton = self.elem.querySelector('[data-ip-four-copy-button]');
        self.ip6CopyButton = self.elem.querySelector('[data-ip-six-copy-button]');
        self.spinner = self.elem.querySelector('[data-spinner]');
        self.toggle = self.elem.querySelector('[data-toggle]');
        self.ip4 = false;
        self.ip6 = false;
    }

    init() {
        let self = this;

        self.getIp4();
    }

    getIp4() {
        let self = this;

        axios.get('https://api.ipify.org?format=json')
            .then(function (response) {
                self.ip4Elem.textContent = response.data.ip;
                self.ip4 = response.data.ip;
            })
            .catch(function (error) {
                return false;
            })
            .finally(function () {
                self.getIp6();
            });
    }

    getIp6() {
        let self = this;

        axios.get('https://api6.ipify.org?format=json')
            .then(function (response) {
                self.ip6Elem.textContent = response.data.ip;
                self.ip6 = response.data.ip;
            })
            .catch(function (error) {
                return false;
            })
            .finally(function () {
                self.initView();
            });
    }
    
    initView() {
        let self = this;

        if(self.ip4 || self.ip6) {
            self.hideSpinner();
        }

        if(self.ip4) {
            self.initIp4CopyButton();
        }

        if(self.ip6) {
            self.initIp6CopyButton();
        }

        if(self.ip4) {
            self.showIp4();
        }
        else if(self.ip6) {
            self.showIp6();
        }

        if(self.ip4 && self.ip6) {
            self.initToggle();
        }
    }

    showIp4() {
        let self = this;

        self.ip4Container.classList.remove('d-none');
    }

    showIp6() {
        let self = this;

        self.ip6Container.classList.remove('d-none');
    }

    hideIp4() {
        let self = this;

        self.ip4Container.classList.add('d-none');
    }

    hideIp6() {
        let self = this;

        self.ip6Container.classList.add('d-none');
    }

    hideSpinner() {
        self.spinner.classList.add('d-none');
    }

    initToggle() {
        let self = this;

        self.toggle.classList.remove('d-none');

        self.toggle.addEventListener('click', evt => {
            if(self.toggle.classList.contains('is-ipv4')) {
                self.toggle.classList.remove('is-ipv4');
                self.toggle.classList.add('is-ipv6');
                self.hideIp4();
                self.showIp6();
            } else {
                self.toggle.classList.add('is-ipv4');
                self.toggle.classList.remove('is-ipv6');
                self.hideIp6();
                self.showIp4();
            }
        });
    }

    initIp4CopyButton() {
        let self = this;

        self.ip4CopyButton.addEventListener('click', function (evt) {
            navigator.clipboard.writeText(self.ip4);

            self.ip4CopyButton.textContent = self.ip4CopyButton.getAttribute('data-copied-text');

            setTimeout(function() {
                self.ip4CopyButton.textContent = self.ip4CopyButton.getAttribute('data-copy-text');
            }, 2000);
        });
    }

    initIp6CopyButton() {
        let self = this;

        self.ip6CopyButton.addEventListener('click', function (evt) {
            navigator.clipboard.writeText(self.ip6);

            self.ip6CopyButton.textContent = self.ip6CopyButton.getAttribute('data-copied-text');

            setTimeout(function() {
                self.ip6CopyButton.textContent = self.ip6CopyButton.getAttribute('data-copy-text');
            }, 2000);
        });
    }
}

export default Ip;
